// extracted by mini-css-extract-plugin
export default {"accused":"MessageAccused_accused__LPLeu"};